export default "__VITE_ASSET__5mMiuBqs__"